import NewIndustrialClientPage from "../pages/NewIndustrialClient/NewIndustrialClient";
import ExistentClientPage from "../pages/ExistentClient/ExistentClient";
import AddressSearchPage from "../pages/AddressSearch/AddressSearch";
import AddressComplementPage from "../pages/AddressComplement/AddressComplement";
import AddressActivePage from "../pages/AddressActive/AddressActive";
import AddressDonePage from "../pages/AddressDone/AddressDone";
import AddressListPage from "../pages/AddressList/AddressList";
import CancellationPage from "../pages/Cancellation/Cancellation";
import ContestationPage from "../pages/Contestation/Contestation";
import SaveTimePage from "../pages/SaveTime/SaveTime";
import ServicesPage from "../pages/Services/Services";
import ServicesConfirmPage from "../pages/ServicesConfirm/ServicesConfirm";
import HomeServicesConfirmPage from "../pages/HomeServicesConfirm/HomeServicesConfirm";
import PrivacyPolicyPage from "../pages/PrivacyPolicy/PrivacyPolicy";
import WarrantyTermsPage from "../pages/WarrantyTerms/WarrantyTerms";
import HomePage from "../pages/Home/Home";
import ConsumptionPage from "../pages/Consumption/Consumption";
import FinancesPage from "../pages/Finances/Finances";
import HomeServicesPage from "../pages/HomeServices/HomeServices";
import HomeDeliveryPage from "../pages/HomeDelivery/HomeDelivery";
import PersonalDataPage from "../pages/PersonalData/PersonalData";
import HelpPage from "../pages/Help/Help";
import InvoicePdfPage from "../pages/InvoicePdf/InvoicePdf";
import AcquittanceLetterPdfPage from "../pages/AcquittanceLetterPdf/AcquittanceLetterPdf";
import DanfePdfPage from "../pages/DanfePdf/DanfePdf";
import AdmnistrativeLoginPage from "../pages/AdmnistrativeLogin/AdmnistrativeLogin";
import FakeLoginPage from "../pages/FakeLogin/FakeLogin";
import AddressSelectPage from "../pages/AddressSelect/AddressSelect";
import IndustrialContactPage from "../pages/IndustrialContact/IndustrialContact";
import ClientRecommendationPage from "../pages/Recommendation/Recommendation";
import ReligueProtocolPage from "../pages/ReligueProtocol/ReligueProtocol";
import ReligueQuestionsPage from "../pages/ReligueQuestions/ReligueQuestions";
import RegisterContaSimPage from "../pages/RegisterContaSim/RegisterContaSim";
import RegisterIndustrialPage from "../pages/RegisterIndustrial/RegisterIndustrial";
import RegisterIndustrialClientPage from "../pages/RegisterIndustrialClient/RegisterIndustrialClient";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import LoginPage from "../pages/Login/Login";
import NewClient from "pages/NewClient/NewClient";
import MyCNPJs from "pages/MyCNPJs/MyCNPJs";
import LinkCnpj from "pages/LinkCnpj/LinkCnpj";
import RegisterCancellation from "pages/RegisterCancellation/RegisterCancellation";
import RegisterCpfAccessPage from "pages/RegisterCpfAccess/RegisterCpfAccess";

export const routes = [
  { path: "/", exact: true, redirect: "/login", isProtected: false },
  { path: "/login", component: LoginPage, isProtected: false },
  {
    path: "/register-client",
    component: RegisterContaSimPage,
    isProtected: false,
  },
  {
    path: "/register-industrial",
    component: RegisterIndustrialPage,
    isProtected: false,
  },
  {
    path: "/register-industrial-client",
    component: RegisterIndustrialClientPage,
    isProtected: false,
  },
  {
    path: "/register-cpf-access",
    component: RegisterCpfAccessPage,
    isProtected: true,
  },
  {
    path: "/new-industrial-client",
    component: NewIndustrialClientPage,
    isProtected: false,
  },
  {
    path: "/reset_password",
    component: ResetPassword,
    isProtected: false,
  },
  {
    path: "/existent-client",
    component: ExistentClientPage,
    isProtected: true,
  },
  { path: "/address-search", component: AddressSearchPage, isProtected: true },
  {
    path: "/address-complement",
    component: AddressComplementPage,
    isProtected: true,
  },
  { path: "/address-active", component: AddressActivePage, isProtected: true },
  { path: "/address-done", component: AddressDonePage, isProtected: true },
  { path: "/address-list", component: AddressListPage, isProtected: true },
  { path: "/address-select", component: AddressSelectPage, isProtected: true },
  { path: "/cancellation", component: CancellationPage, isProtected: true },
  {
    path: "/register-cancellation",
    component: RegisterCancellation,
    isProtected: true,
  },
  { path: "/contestation", component: ContestationPage, isProtected: true },
  { path: "/save-time", component: SaveTimePage, isProtected: true },
  { path: "/services", component: ServicesPage, isProtected: true },
  { path: "/new-client", component: NewClient, isProtected: true },
  { path: "/link-cnpj", component: LinkCnpj, isProtected: true },
  { path: "/my-cnpjs", component: MyCNPJs, isProtected: true },
  {
    path: "/services-confirm",
    component: ServicesConfirmPage,
    isProtected: true,
  },
  {
    path: "/home-services-confirm",
    component: HomeServicesConfirmPage,
    isProtected: true,
  },
  { path: "/privacy-policy", component: PrivacyPolicyPage, isProtected: true },
  { path: "/warranty-terms", component: WarrantyTermsPage, isProtected: true },
  {
    path: "/home",
    component: HomePage,

    isProtected: true,
  },
  {
    path: "/consumption",
    component: ConsumptionPage,
    isProtected: true,
  },
  {
    path: "/finances",
    component: FinancesPage,
    isProtected: true,
  },
  { path: "/home-services", component: HomeServicesPage, isProtected: true },
  { path: "/home-delivery", component: HomeDeliveryPage, isProtected: true },
  { path: "/personal-data", component: PersonalDataPage, isProtected: true },
  { path: "/help", component: HelpPage, isProtected: true },
  { path: "/invoice-pdf", component: InvoicePdfPage, isProtected: true },
  {
    path: "/consigaz/invoice-pdf",
    component: InvoicePdfPage,
    isProtected: true,
  },
  {
    path: "/acquittance-letter-pdf",
    component: AcquittanceLetterPdfPage,
    isProtected: true,
  },
  { path: "/danfe-pdf", component: DanfePdfPage, isProtected: true },
  { path: "/consigaz/danfe-pdf", component: DanfePdfPage, isProtected: true },
  {
    path: "/industrial-contact",
    component: IndustrialContactPage,
    isProtected: true,
  },
  {
    path: "/recommendation",
    component: ClientRecommendationPage,
    isProtected: true,
  },
  {
    path: "/religue-protocol",
    component: ReligueProtocolPage,
    isProtected: true,
  },
  {
    path: "/religue-questions",
    component: ReligueQuestionsPage,
    isProtected: true,
  },
  {
    path: "/admnistrative-login",
    component: AdmnistrativeLoginPage,
    isProtected: true,
  },
  { path: "/fake-login", component: FakeLoginPage, isProtected: true },
];
